type ColumnBounds = {
  size: number;
  minSize: number;
};

// Widths render as shares of the total, so the narrowest table that still
// honours every minimum is the one where the tightest column reaches its own.
export const getTableMinWidth = (columns: ColumnBounds[]): number => {
  const totalSize = columns.reduce((sum, { size }) => sum + size, 0);

  const tightestShare = columns.reduce(
    (share, { size, minSize }) =>
      size > 0 ? Math.max(share, minSize / size) : share,
    0,
  );

  return Math.ceil(totalSize * tightestShare);
};
